import React, { useMemo } from "react";

/**
 * Fixed, page-wide rising bubbles background.
 * PURE CSS animation (no framer-motion) — one GPU-composited layer per bubble,
 * random durations/x-drift via CSS custom properties. Much lighter than JS-per-frame.
 */
const BubblesBackground = ({ variant = "light", density = 14 }) => {
    const bubbles = useMemo(() => {
        const arr = [];
        for (let i = 0; i < density; i++) {
            const size = Math.round(8 + Math.random() * 84);
            const left = Math.round(Math.random() * 100);
            const duration = 14 + Math.random() * 16;
            const delay = -Math.random() * duration;
            const drift = Math.round(-30 + Math.random() * 60);
            const opacity = 0.35 + Math.random() * 0.5;
            arr.push({ size, left, duration, delay, drift, opacity, id: i });
        }
        return arr;
    }, [density]);

    return (
        <div
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
            data-testid="bubbles-bg"
        >
            {bubbles.map((b) => (
                <span
                    key={b.id}
                    className={`bubble bubble-anim ${variant === "dark" ? "bubble--dark" : ""}`}
                    style={{
                        width: b.size,
                        height: b.size,
                        left: `${b.left}%`,
                        bottom: `-${b.size + 40}px`,
                        opacity: b.opacity,
                        animationDuration: `${b.duration}s`,
                        animationDelay: `${b.delay}s`,
                        // Pass drift into CSS var so keyframes can consume it
                        "--drift": `${b.drift}px`,
                    }}
                />
            ))}
        </div>
    );
};

export default BubblesBackground;
